import { combineReducers } from "@reduxjs/toolkit";

import { buildingsListingReducer } from "./BuildingsListingSlice";

export const buildingsReducer = combineReducers({
  buildingsListing: buildingsListingReducer,
});
